import { ajax } from '../../../services/helper'
class ApiService {

    getDepartmentsData = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/departments/list"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    addDepartments = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/departments/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    getDepartmentsById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/departments/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     editDepartments = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/departments/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     getcostCenterDetailList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/costCenters/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }    

    getEmployeesListData = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }    

    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Departments/services/apiservices.js